module.exports = __webpack_public_path__ + "img/first_down_right.fa282fc3.jpg";